// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accessibleView":"Nc8aJ"};